import { render } from "./fase_localizacao.vue?vue&type=template&id=5b83e849"
import script from "./fase_localizacao.vue?vue&type=script&lang=js"
export * from "./fase_localizacao.vue?vue&type=script&lang=js"

import "./fase_localizacao.vue?vue&type=style&index=0&id=5b83e849&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__